import { Paper, styled, PaperProps } from '@mui/material';

export const ElevatedPaper = styled((props: PaperProps) => <Paper elevation={4} {...props} />)(
    ({ theme }) => ({
        padding: theme.spacing(2),
        display: 'block',
        textDecoration: 'none',
    })
);
